/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-refresh/only-export-components */
import { createContext, useState, useContext, useEffect } from 'react'
import { Hub } from 'aws-amplify/utils'
import { fetchUserAttributes, signOut } from 'aws-amplify/auth'
import PropTypes from 'prop-types'
import { saveUserDetails, getUserDetails, removeUserDetails } from '@/storage/local-storage'
import { useSharedLoginSession } from '@/hooks/use-shared-login-session'

const AuthContext = createContext()

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(getUserDetails())
  const [loading, setLoading] = useState(true)
  const { startSessionTick, clearSessionTick, isActiveSession } = useSharedLoginSession()
  const authenticated = !!user && isActiveSession()

  useEffect(() => {
    const logoutIfSessionExpired = async () => {
      try {
        if (!authenticated && user) {
          await logout()
        }
      } catch (error) {
        console.error('Error during logoutIfSessionExpired:', error)
      }
    }
    logoutIfSessionExpired()
  }, [authenticated, user])

  async function setUserContext() {
    try {
      const user = await fetchUserAttributes()
      setUser(user)
      saveUserDetails(user)
      startSessionTick()
    } catch (err) {
      console.log(err)
    }
    setLoading(false)
  }

  async function logout() {
    await signOut()
    setUser(null)
    removeUserDetails()
    clearSessionTick()
  }

  // Handle authentication events
  useEffect(() => {
    const unsubscribe = Hub.listen('auth', async ({ payload }) => {
      switch (payload.event) {
        case 'signedIn':
          console.log('user have been signedIn successfully.')
          await setUserContext()
          break
        case 'signedOut':
          console.log('user have been signedOut successfully.')
          break
        case 'tokenRefresh':
          console.log('auth tokens have been refreshed.')
          await setUserContext()
          break
        case 'tokenRefresh_failure':
          console.log('failure while refreshing auth tokens.')
          break
        case 'signInWithRedirect':
          console.log('signInWithRedirect API has successfully been resolved.')
          break
        case 'signInWithRedirect_failure':
          console.log('failure while trying to resolve signInWithRedirect API.')
          break
        case 'customOAuthState':
          console.log('custom state returned from CognitoHosted UI')
          break
      }
    })

    return () => {
      unsubscribe()
    }
  }, [])

  return (
    <AuthContext.Provider
      value={{
        user,
        logout,
        setUser,
        loading,
        authenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

AuthProvider.propTypes = {
  children: PropTypes.element,
}

const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within a AuthProvider')
  }
  return context
}

export { AuthProvider, useAuth }
